import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
/**
 * shadcn-style `<table>` primitives. The outer wrapper provides horizontal
 * scrolling so wide tables don't break the layout; consumers can override
 * via `className` on each slot.
 */
function Table({ className, ...props }) {
    return (_jsx("div", { className: "relative w-full overflow-auto", "data-slot": "table-container", children: _jsx("table", { className: cn('w-full caption-bottom text-sm', className), "data-slot": "table", ...props }) }));
}
function TableHeader({ className, ...props }) {
    return (_jsx("thead", { className: cn('[&_tr]:border-b', className), "data-slot": "table-header", ...props }));
}
function TableBody({ className, ...props }) {
    return (_jsx("tbody", { className: cn('[&_tr:last-child]:border-0', className), "data-slot": "table-body", ...props }));
}
function TableFooter({ className, ...props }) {
    return (_jsx("tfoot", { className: cn('bg-muted/50 border-t font-medium [&>tr]:last:border-b-0', className), "data-slot": "table-footer", ...props }));
}
function TableRow({ className, ...props }) {
    return (_jsx("tr", { className: cn('hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors', className), "data-slot": "table-row", ...props }));
}
function TableHead({ className, ...props }) {
    return (_jsx("th", { className: cn('text-muted-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className), "data-slot": "table-head", ...props }));
}
function TableCell({ className, ...props }) {
    return (_jsx("td", { className: cn('p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className), "data-slot": "table-cell", ...props }));
}
function TableCaption({ className, ...props }) {
    return (_jsx("caption", { className: cn('text-muted-foreground mt-4 text-sm', className), "data-slot": "table-caption", ...props }));
}
export { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow, };
